import React, { useState, useEffect, useRef } from "react";
import "./LocationAutocomplete.css";

function LocationAutocomplete({ value, onChange, required }) {
  const [suggestions, setSuggestions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");
  const wrapperRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  // Fetch suggestions from API
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (inputValue.length < 2) {
        setSuggestions([]);
        return;
      }

      try {
        const response = await fetch(
          `https://geo.api.gouv.fr/communes?nom=${encodeURIComponent(inputValue)}&fields=nom,code,codesPostaux,departement&boost=population&limit=8`
        );
        const data = await response.json();
        setSuggestions(data);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
      }
    };

    const timeoutId = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(timeoutId);
  }, [inputValue]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange({ target: { name: "location", value: newValue } });
    setIsOpen(true);
  };

  const handleSuggestionClick = (suggestion) => {
    const locationText = `${suggestion.nom} (${suggestion.codesPostaux[0]})`;
    setInputValue(locationText);
    onChange({ target: { name: "location", value: locationText } });
    setIsOpen(false);
    setSuggestions([]);
  };

  return (
    <div className="location-autocomplete" ref={wrapperRef}>
      <input
        type="text"
        id="location"
        name="location"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => inputValue.length >= 2 && setIsOpen(true)}
        required={required}
        placeholder="Paris, Lyon, Marseille..."
        autoComplete="off"
      />
      {isOpen && suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map((suggestion) => (
            <li
              key={suggestion.code}
              onClick={() => handleSuggestionClick(suggestion)}
              className="suggestion-item"
            >
              <div className="suggestion-main">
                <span className="suggestion-name">{suggestion.nom}</span>
                <span className="suggestion-postal">{suggestion.codesPostaux[0]}</span>
              </div>
              <span className="suggestion-dept">{suggestion.departement.nom}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LocationAutocomplete;
